export const environment = {
  production: true,
  testServeWait: 1000,
  isEnablePutRecord: true,
  isTestServer: false,
  gtag_id: 'GTM-0000000',
  hotjar_id: '',
  hotjar_version: 6,
  optimize: false,
  random_percentage: 10,
  re_captcha_public_key: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
  api_url: 'https://mo-services-bbva-bnpl-pe-alpha.moprestamo.com',
  url: '',
  documents_bucket: '/assets/documents',
  portal_url: 'https://payments-portal-bnpl-pe-bbva.moprestamo.com/',
  landing_url: 'https://bbva-bnpl-pe-landing-portal-alpha.moprestamo.com/',
  chatbot: false,
  openpay_merchant_id: 'mj8xoqhjwf23utzs06vt',
  openpay_public_api_key: 'pk_588b1da7f29949bcac527d798b9c653d',
  openpay_sandbox_mode: 'true',
  openpay_url: 'https://sandbox-api.openpay.pe/v1/', // sandbox to dev
  privacy_policy_url:
    'https://bbva-bnpl-pe-alpha-template-storage.s3.amazonaws.com/documents/powerpay-politica-privacidad.pdf',
  terms_and_conditions_merchant_policy_url:
    'https://bbva-bnpl-pe-alpha-template-storage.s3.amazonaws.com/documents/powerpay-terminos-y-condiciones-merchant.pdf',
  terms_and_conditions_contract_url:
    'https://bbva-bnpl-pe-alpha-template-storage.s3.amazonaws.com/documents/powerpay-terminos-y-condiciones-contrato.pdf',
  terms_and_conditions_enduser_policy_url:
    'https://bbva-bnpl-pe-alpha-template-storage.s3.amazonaws.com/documents/Powerpay_TerminosCondicionesEndUser.pdf',
};
